import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import NovoUsuario from './NovoUsuario';
import FichaUsuario from './FichaUsuario';

//Api
import usuario_api from '../../../api/usuario_api';
import { showMessage } from '../../../helpers/message';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function Usuarios({ permissao }) {

    //Estado que guarda os dados dos usuarios para a listagem
    const [usuarios, setUsuarios] = useState([]);

    //Estado para controle da tela de novo usuario
    const [novo, setNovo] = useState(false);

    //Estado de controle da tela de ficha de usuario
    const [ficha, setFicha] = useState(null);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega os usuarios para listagem na tela
    const loadUsuarios = () => {
        setLoading(true);
        usuario_api.getList().then(response => {
            response.data = response.data.map(value => {
                value.cpfcnpj = mascaras.cpfcnpjMask(value.cpfcnpj);
                return value;
            });
            setUsuarios(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error"))
            .finally(f => setLoading(false));
    }

    //Faz com que a tela da listagem fique ativa novamente
    const onClickBtnVoltar = () => {
        setNovo(false);
        setFicha(null);
        loadUsuarios();
    }

    //Carrega todos os usuarios da listagem assim que o componente é iniciado
    useEffect(() => {
        loadUsuarios();
    }, []);

    //Ações da tabela de listagem
    const actions = [
        actionsTable.visualizar((rowData) => setFicha(rowData.id))
    ]
    //cabeçalhos da tabela de listagem
    const headers = [
        { value: "Nome", objectValue: "nome" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj" },
        { value: "Perfil", objectValue: "perfil" },
        { value: "Status", objectValue: "status" },
    ];

    if (novo) {
        return (
            <NovoUsuario
                btnVoltar={onClickBtnVoltar}
            />
        )
    }

    if (ficha) {
        return (
            <FichaUsuario
                btnVoltar={onClickBtnVoltar}
                id={ficha}
                permissao={permissao}
            />
        )
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard
                noCard
                btnCadastro={permissao === "Editar" ? "Adicionar" : null}
                onClickBtnCadastro={() => setNovo(true)}
            >
                <div className="mt-4">
                    <TabelaListagem
                        title={"Lista de usuários"}
                        items={usuarios}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers} actions={actions}
                    />
                </div>
            </MainCard>
        </>
    )
}